import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["b", "c", "e", "f", "n", "p", "s", "w"]

  triggerAction({ key }) {
    // We need this because even with optional chaining this.xTarget will throw an error if target "x "is not defined.
    if (!(key && this[`has${key.toUpperCase()}Target`])) {
      return
    }

    // We need to use optional chaining here because if key is "B" instead of "b" then it won't be catched by the guard clause.
    this[`${key}Target`]?.click()
  }
}
